import { Route, Navigate, useParams, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { InstitutionSignInComponent } from './components/InstitutionSignInComponent';
import { InstitutionRegisterComponent } from './components/InstitutionRegisterComponent';
import { InstitutionForgotPasswordComponent } from './components/InstitutionForgotPasswordComponent';
import { CompleteRegistrationComponent } from './components/CompleteRegistrationComponent';

export const AUTHENTICATION_ROUTES = {
    SIGN_IN: { path: '/:urlPrefix/sign-in' },
    JOIN: { path: '/:urlPrefix/join' },
    JOIN_ACCOUNT: { path: '/:urlPrefix/join/account' },
    CANDIDATES_SIGNUP: { path: '/:urlPrefix/candidates/signup' },
    FORGOT_PASSWORD: { path: '/:urlPrefix/forgot-password' },
    COMPLETE_REGISTRATION: { path: '/complete-registration' },
};

export function configureAuthenticationRoutes() {
    return [
        {
            routes: AUTHENTICATION_ROUTES,
            config: {
                removeAppShell: true,
            },
        },
    ];
}

export function getAuthenticationRoutes() {
    return (
        <Route id="authentication-routes" element={<Outlet />}>
            <Route
                path={AUTHENTICATION_ROUTES.SIGN_IN.path}
                element={
                    <ProtectedRoute accessPolicy="notLoggedIn">
                        <InstitutionSignInComponent />
                    </ProtectedRoute>
                }
            />
            <Route path={AUTHENTICATION_ROUTES.JOIN.path} element={<InstitutionJoinRedirect />} />
            <Route
                path={AUTHENTICATION_ROUTES.JOIN_ACCOUNT.path}
                element={
                    <ProtectedRoute accessPolicy="notLoggedIn">
                        <InstitutionRegisterComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={AUTHENTICATION_ROUTES.CANDIDATES_SIGNUP.path}
                element={
                    <ProtectedRoute accessPolicy="notLoggedIn">
                        <InstitutionRegisterComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={AUTHENTICATION_ROUTES.FORGOT_PASSWORD.path}
                element={
                    <ProtectedRoute accessPolicy="notLoggedIn">
                        <InstitutionForgotPasswordComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={AUTHENTICATION_ROUTES.COMPLETE_REGISTRATION.path}
                element={
                    <ProtectedRoute accessPolicy="requiresProfileConfirmation">
                        <CompleteRegistrationComponent />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}

function InstitutionJoinRedirect() {
    let { urlPrefix } = useParams<{ urlPrefix: string }>();

    // Handle Cordova forced URL prefix (same logic as Angular's loadJoinAndRedirect resolver)
    if (window.CORDOVA?.forcedUrlPrefix) {
        urlPrefix = window.CORDOVA.forcedUrlPrefix;
    }

    if (!urlPrefix) {
        throw new Error('urlPrefix required');
    }

    const searchParams = new URLSearchParams(window.location.search);
    const search = searchParams.toString();
    return <Navigate to={`/${urlPrefix}/join/account${search ? `?${search}` : ''}`} replace />;
}
